import e from "react";
export default function (t) {
  var r = e.useState(!1),
      n = r[0],
      a = r[1],
      c = e.useRef(null);
  return e.useEffect(function () {
    var e = !0;
    window && window.matchMedia && (c.current = window.matchMedia(t));
    var r = c.current;
    r && n !== r.matches && a(r.matches);

    var u = function u(t) {
      e && a(t.matches);
    };

    return r && r.addListener(u), function () {
      e = !1, r && r.removeListener(u);
    };
  }, [t, n]), n;
}